import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Download from "../../../../Components/Download/Download";
import { intToTime } from "../../../../Components/Global";
import Spinner from "../../../../Components/Spinner/Spinner";
import { api } from "../../../..";
import Utils from "../../../../vendor/weblink/nguc-javascript-client/Utils";
import moment from "moment";
import { toast } from "react-toastify";

let unique = -1;

const AgentStatistics = (props:any) => {
    const [members, setMembers] = useState<any>({});
    const [memberIds, setMemberIds] = useState([]);
    const { t } = useTranslation();
    const { id } = useParams();

    useEffect(() => {
        if(id) {
            setMembersData(props.queueCdr)
		}

	}, [props.queueCdr, id]);

    const setMembersData = (queueCdr:any) => {
        const members: any = {}
        const members2: any = []

        if(queueCdr) {
            for(const queue in queueCdr) {
                members2.push(queueCdr[queue].pbx_user_id)
            }

            const unq = members2.filter((m:any, i:any) => {
                return members2.indexOf(m) === i
            })

            for(const member of unq) {
                members[member] = {
                    agent: '',
                    calls: 0,
                    totalTalkTime: 0
                }

                for(const call of queueCdr) {
                    if(call.pbx_user_id === member) {
                        members[member].agent = call.answered_by
                        members[member].calls++

                        if(member !== null) {
                            members[member].totalTalkTime += parseInt(call.talk_time)
                        }

                    }
                }
            }

            setMemberIds(unq)
            setMembers(members);
        }
    }

    if(props.loading) {
		return <div className="callout">
			<div className="agents">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

    Object.keys(members).sort((a: any, b: any) => a[1] - b[1])

    return<div className="callout">
        <div className="agents">
			<div className="header-top-bar">
				<div>
					<b>{t('agents_statistics')}</b>
				</div>
				<div>
					<Download
						onChange={(event:any) => {
							api.calls.queue.cdr.member.download(event.value, {
								'queues[]': id ?? '',
								datetime_from: props.dateFrom ? props.dateFrom : moment().format('YYYY-MM-DD'),
								datetime_to: props.dateTo ? props.dateTo : '',
								limit: 1000
							})
							.then((r:any) => {
								Utils.downloadDataFile(
									t('agents')+ '.' + (event.value === 'excel' ? 'xlsx' : event.value),
									new Blob([r.data])
								)
							})
							// eslint-disable-next-line @typescript-eslint/no-unused-vars
							.catch((r:any) => {
								toast.error(t('something_went_wrong_please_try_again'))
							})
						}}
					/>
				</div>
			</div>
            <div className="row agents-data">
                <div className="small-12 medium-12 large-12 columns">
                    <table className="unstriped">
                        <thead>
                            <tr>
                                <th>
                                    <b>{t('agent')}</b>
                                </th>
                                <th>
                                    <b>{t('calls')}</b>
                                </th>
                                <th>
                                    <b>{t('talk_time')}</b>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                memberIds.length !== 0 ?
                                    memberIds.map((m: any) => {
										return <tr key={unique--} className={(m === null) ? 'hide' : ''}>
										<td>{m === null ? 'NO ANSWER'  :  members[m].agent}</td>
                                            <td>{members[m].calls}</td>
                                            <td>{intToTime(members[m].totalTalkTime)}</td>
                                        </tr>
                                    })
                                :
                                    <tr>
                                        <td className="center-text" colSpan={3}>{t('no_data_found')}</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
}

export default AgentStatistics;
